export var VisualModelDataVersion;
(function (VisualModelDataVersion) {
    VisualModelDataVersion[VisualModelDataVersion["VERSION_0"] = 0] = "VERSION_0";
    /**
     * Changes from previous version:
     * - edges detected based on decimal position
     * - model assigned to UNKNOWN_MODEL
     */
    VisualModelDataVersion[VisualModelDataVersion["VERSION_1"] = 1] = "VERSION_1";
})(VisualModelDataVersion || (VisualModelDataVersion = {}));
;
export const VISUAL_MODEL_TYPE = "visual-model";
export function isVisualModel(what) {
    return isTypedObject(what) && what.getTypes().includes(VISUAL_MODEL_TYPE);
}
function isTypedObject(what) {
    return typeof what === "object" && what !== null && "getTypes" in what;
}
//# sourceMappingURL=visual-model.js.map